/* You must register this file at "website\src\i18n\en-us" */

export default {
    /* Global Vocabulary */
    heads_up: 'Heads up',
    attention: 'ATTENTION',
    pay: 'Pay',
    pay_now: 'Pay now',
    please_wait: 'Please wait',
    close: 'Close',
    notice: 'Notice',
    dismiss: 'Dismiss',
    accepted_proof: 'Accepted proof',
    rejected: 'Rejected',
    upload: 'Upload',
    receipt: 'Receipt',
    receipt_unavailable:'Receipt Unavailable',
    request_receipt: 'Request Receipt',
    fast: 'Fast',
    fee: 'Fee',

    /* Module special vocabulary */
    transfers: {
        menu: {
            index: 'Orders',
            create: 'New order',
            advanced_create: 'New advanced order',
            advanced_edit: 'Edit order',
            list: 'Orders',
            "send-money": 'Rebit',
            history: "Tracking",
            matchmaking: 'Matchmaking',
            ift: 'IFT',
        },
        table_titles: {
            id: 'ID',
            user: 'User',
            assignee: 'Assignee',
            incoming_details: 'Incoming details',
            outgoing_details: 'Outgoing details',
            recipient_name : 'Recipient',
            recipient_account : 'Recipient\'s details',
            recipient_account_type : 'Recipient Account Type',
            recipient_account_number : 'Recipient Account Number',
            reason : 'Reason',
            sent_amount : 'You sent',
            received_amount : 'They received',
            reference : 'Reference',
            incoming_account: 'Incoming account',
            rate : 'Rate',
            notify: 'Notify',
            status : 'Status',
            type : 'Type',
            ift_date : 'IFT date',
            note : 'Note',
            notes : 'Notes',
            rebit_account: 'Rebit Account',
            service_fee: 'Service fee',
            risk_score: 'Risk score',
            referral_earnings: 'Referral Earnings',
            reward_fee: 'Reward/Fee',
            user_bank_account: "User's bank account",
            registered_at : 'Registered',
            updated_at : 'Update Date/Time',
            setting: 'Settings',
        },
        withdrawal_table_titles: {
            id: 'ID',
            amount: 'Amount',
            transfer_reference: 'Transfer reference',
            from_currency: 'From currency',
            to_currency: 'To currency',
            outstanding_amount: 'Outstanding amount',
            order_payments: 'Order payments',
            pre_assigned_code: 'Pre assigned code',
            reference: 'Reference',
            sent_payment_to_country: 'Sent payment to country',
            bank_name: 'Bank',
            to_account_number: 'To account number',
            swift_bic: 'Swift BIC',
            bank_account_name: 'Bank account name',
            bank_owner_address_1: 'Bank owner address 1',
            bank_owner_address_2: 'Bank owner address 2',
            bank_owner_address_country: 'Bank owner address country',
        },
        ift_table_titles: {
            reference: "Reference",
            customer: "Customer",
            customer_email: "Customer\'s email",
            gender: "Gender",
            date_of_birth: "Date of birth",
            id_document: "Id document",
            status_updated_at: "Transferred at",
            actions: 'Actions'
        },
        payment_details_table: {
            date: 'Date (UTC)',
            amount: 'Amount',
            method: 'Method',
            status: 'Status',
        },
        matchmaking: {
            incoming_orders: 'Incoming',
            outgoing_orders: 'Outgoing',
            transfer_reference: 'Reference',
            details: 'Details',
            amount: 'Amounts',
            order_payments: 'Order Payments',
            transaction_amount: 'Transaction Amount',
            incoming_payment_method: 'Incoming Payment Method',
            outgoing_payment_method: 'Outgoing Payment Method',
        },
        send_money_steps: {
            user: 'User',
            amount: 'Amount',
            recipient: 'Recipient',
            review: 'Review',
            continue: 'Continue',
            guaranteed_rate: 'Guaranteed rate',
            no_user_found: 'No User found',
            recipient_s_details: 'Recipient\'s details',
            who_are_you_sending_money_to: 'Who are you sending money to?',
            select_your_recipient: 'Select your recipient',
            reason_for_transfer: 'Reason for transfer',
            pay_quickly_to_avoid_rate_fluctuations: 'Pay {total_amount} quickly, to avoid rate fluctuations.',
            you_send: 'You send',
            service_fee: 'Service fee',
            rewards_discount: 'Rewards discount',
            total_to_pay: 'Your total payable',
            recipient_gets: '{recipient} gets',
            recipient_gets_title: 'Recipient gets',
            transfer_time: 'Transfer time',
            we_ll_deposit_your_origin_amount_as_soon_as_we_confirm_receipt_of_your_dest_amount: 'We\'ll deposit your {origin_amount} as soon as we confirm receipt of your {dest_currency}.',
            the_transfer_time_window_is_target_only_and_it_s_subject_to_the_availability_of_the_bank_networks_and_local_operators: 'The Transfer Time window is target only and it\'s subject to the availability of the bank networks and local operators.',
            send_payment_receipts: 'Send Payment Receipts',
            please_upload_payment_receipt_for_this_order: 'Please upload payment receipt for this order.',
            we_ll_update_your_order_status_shortly: 'We\'ll update your order status shortly.',
            file_already_uploaded: '{number_of_files} file already uploaded',
            files_already_uploaded: '{number_of_files} files already uploaded',
            payment_receipts: 'Payment Receipts',
            change: 'Change',
            exchange_rate_expired: 'Exchange rate expired!',
            seems_your_data_is_out_of_date_let_s_try_again: 'Seems your data is out of date. Let\'s try again',
            start_over: 'Start over',
            duplicate_order: 'Duplicate order',
            an_order_already_exist_for_this_recipient: 'An order already exist for this recipient. Please complete the existing order, or contact support.',
            view_existing_oder: 'VIEW EXISTING ORDER',
            inactive_currency: 'Inactive currency',
            demand_for_this_route_is_currently_high_and_we_re_unable_to_accept_more_orders: 'Demand for this route is currently high and we\'re unable to accept more orders.',
            please_try_later: 'Please try later.',
            before_we_continue: 'Before we continue',
            we_need_to_collect_a_few_more_details: 'We need to collect a few more details.',
            complete_verification: 'Complete Verification',
            bank_account: 'Bank Account',
            edit_amounts: 'Edit amounts',
            change_recipient: 'Change recipient',
            payable: 'Payable'
        },
        tracking: {
            all_you_paid: 'All you paid',
            all_we_paid: 'All we paid',
            details: 'Details',
            timeline: 'Timeline',
            we_paid: 'We paid',
            you_paid: 'You paid',
            pay_now: 'Pay now',
            send_receipts: 'Send Receipts',
            cancel_order: 'Cancel order',
            edit_recipient: 'Edit recipient',
            rate_us: 'Rate us',
            upload_payment_receipts_here_when_needed: 'Upload payment receipts here, when needed.',
            statuses: {
                created: 'Order created',
                awaiting: 'Awaiting approval',
                ready_to_pay: 'Ready to pay {currency}',
                processing_payment: 'Processing {currency} payment',
                payment_issue: 'Payment issue ({currency})',
                paid: '{currency} Paid',
                transfer_issue: 'Transfer issue ({currency})',
                transferred: 'Transferred',
                canceled: 'Cancelled',
            },
            timeline_statuses: {
                canceled: 'Your order has been cancelled.',
                transferred: 'Transferred',
                payment_issue: 'Payment issue',
                transfer_issue: 'Transfer issue',
                you_paid: 'You paid',
                there_was_an_issue_with_your_payment: 'There was an issue with your payment. Please check your email for details. <br>There might be delays in processing your order due to this.',
                please_contact_us_if_your_transfer_is_urgent: 'Please {contact_us} if your transfer is urgent.',
                contact_us: 'Contact us',
                for_poli_payment: 'For POLi payments, your fund may arrive later but we’re already processing the payment to your recipient.',
                we_have_received_your_order: 'Received your order.',
                we_ll_notify_you_once_order_is_ready_to_pay: 'We\'ll notify you once order is ready to pay {currency}.',
                your_payment_will_be_confirmed_in_the_next_cycle: 'Your payment will be confirmed in the next cycle',
                you_ll_complete_the_payment_and_upload_receipts: 'You\'ll complete the payment and upload receipts.',
                we_ll_approve_your_payment: 'We\'ll approve your {currency} payment.',
                we_have_paid_amount_to_recipient_name: 'We have paid {received_amount} to {recipient_name}.',
                order_is_ready_to_pay_currency: 'Order is ready to pay {currency}.',
                complete_the_payment_and_upload_receipts: 'Complete the payment and upload receipts.',
                you_ve_uploaded_some_receipts: 'You\'ve uploaded some receipts.',
                we_re_approving_your_currency_payment: 'We\'re approving your {currency} payment.',
                converting_your_sent_amount_now: 'Converting your sent amount now',
                your_total_amount_payment_is_confirmed: 'Your {total_amount} payment is confirmed. Thank you!',
                we_will_be_paying_received_amount_to_recipient_name_s_account_shortly: 'We will be paying {received_amount} to {recipient_name}\'s account shortly.',
                please_check_your_email_and_follow_the_instructions: 'Please check your email and follow the instructions.',
                estimated_settlement_time: 'Estimated settlement time: {transfer_time}',
                anti_money_laundering: 'You must pay from {sender_name}\'s account. ',
                depending_on_local_banks_networks: "Depending on local banks networks, {recipient_name} should receive it shortly."
            },
            loading_label: 'Loading transfer history...',
            processing: 'Processing',
            accepted: 'Accepted',
            cancelled: 'Canceled',
            if_your_transfer_is_urgent_you_can_send_us_a_screenshot_of_your_payment: 'If your transfer is urgent, you can send us a screenshot of your payment and we\'ll try our best to make it faster.',
            although_we_process_orders_every_day_sending_us_your_payment_screenshot: 'Although we process orders every day sending us your payment screenshot could be useful, especially over weekends.',
            you_can_use_chat_icon_to_do_so: "You can use {icon} Chat icon to do so.",
            open_chat: 'Open Chat',
            sweet: 'Sweet',
            too_late_to_cancel: 'Too late to Cancel!',
            we_have_already_set_up_a_payment_plan_for_this_order: 'We have already set up a payment plan for this order.',
            if_you_need_to_cancel_this_order_please_get_in_touch_with_support_immediately: "If you need to cancel this order, please get in touch with Support immediately.",
            help_and_support: 'Help & support',
            dismiss: 'Dismiss',
            cancel_transfer_order: 'Cancel Transfer Order',
            we_will_stop_processing_your_order: 'We will stop processing your order. But this will still use your monthly transfer capacity.',
            recipient_gets: '{recipient} gets',
            tracking_code_copied: 'Tracking code copied!',
            download_receipt: 'Download receipt {number}',
        },
        third_party_payments: {
            accepted_payment: 'Accepted payment',
            pending_payment: 'Pending payment',
            bank_name: 'Bank name',
            account_number_copied: 'Account number copied!',
            account_number_do_not_save: 'Account number <span class="text-negative inline-block">Do NOT save</span>',
            recipient_s_name_copied: 'Recipient\'s name copied!',
            account_name: 'Account Name',
            amount_toman: 'Amount (Toman)',
            toman: 'Toman',
            rial: 'Rial',
            amount_copied: 'Amount copied!',
            amount: 'Amount',
            outstanding: 'Outstanding',
            remaining_payments_will_show_up_here: 'Remaining payments will show up here...',
            please_visit_again: 'Please visit again!',
            leave_blank: 'Leave blank'
        },
        total_accepted_payments: 'Total accepted payments',
        outstanding_amount: 'Outstanding amount',
        copy_txid: 'Copy TXID',
        recipient_bank: 'Bank',
        recipient_account_number: 'Account number',
        fees: 'Fees',
        "on-ramp": 'On ramp',
        "off-ramp": 'Off ramp',
        origin_amount: 'Sending amount',
        dest_amount: 'Received amount',
        service_fee: 'Service fee',
        referral_earnings: 'Total Reward',
        target_buy_rate: 'Target Buy Rate',
        target_sell_rate: 'Target Sell Rate',
        on_ramp_margin: 'On Ramp Margin',
        off_ramp_margin: 'Off Ramp Margin',
        order_reference: 'Tracking Code',
        rate: 'Rate',
        rewards: 'Rewards',
        total_to_pay: 'Total to pay',
        gets: 'gets',
        payment_method: 'Payment method',
        user: 'User',
        edit: 'Edit Transfer',
        you_sent: 'You sent',
        cm_withdrawals: 'Withdrawals',
        cm_transactions: 'Sync Transactions',
        withdraw: 'Withdraw',
        history: "Transfers History",
        report_to_police: "NZ IFT",
        you_already_have_an_open_order: 'You already have an open order!',
        pay_for_existing_order: 'Pay for existing order',
        create_a_new_order: 'Create a new order',
        order_limit: 'Order Limit',
        increase_limits: 'Increase Limits',
        verify_source_of_funds_to_increase_your_limits: 'Verify Source of Funds to increase your limits',
        send_additional_documents: 'Send additional documents',
        our_bank_account: 'Our bank account',
        thanks_for_your_patience_while_we_assign_a_bank_account_to_your_order: 'Thanks for your patience while we assign a bank account to your order!',
        you_can_close_this_page: 'You can close this page, now.',
        your_order_is_queued_now: 'Your order is successfully queued.',
        please_do_not_make_any_deposits_to_previous_bank_accounts: "Please DO NOT make any deposits to previous bank accounts.",
        once_admins_confirm_the_account_number_we_ll_notify_you_to_revisit_this_page: "Once admins confirm the account number, we'll notify you to revisit this page.",
        payment_details: 'Payment details',
        please_deposit_the_amount_into_the_following_account: "Please deposit the amount(s) into the following account(s).",
        avoid_bank_references_like: 'Avoid bank references like {transfer}, {iran}, {rebit}, etc.',
        avoid_paying_from_ASB: 'Avoid paying from {ASB}.',
        transfer: 'Transfer',
        iran: 'Iran',
        rebit: 'Rebit',
        upload_a_receipt_for_each_transaction: 'Upload a receipt for each transaction.',
        copy_all_details: 'Copy all details',
        all_details_copied: 'All Details copied!',
        send_receipt: 'Send Receipt',
        track_this_order: 'Track this order',
        rebit_more_money: 'Rebit more money',
        processing: 'Processing',
        if_you_can_t_pay_immediately_please_find_the_pay: 'If you can\'t pay immediately, please find the PAY NOW link on the Tracking page.',
        pay_by_method: 'Pay by {method}',
        transaction_fee: 'Transaction fee',
        back_to_payment_options: 'BACK TO PAYMENT OPTIONS',
        delay_warning: 'Delay warning',
        nzd_deposits_at_this_time: 'NZD deposits at this time (Friday/Saturday/Sunday NZST) will be processed on the following Monday.',
        select_another_method: 'Select another method',
        please_upload_receipt_for_each_transaction_separately: 'Please upload receipt for each transaction separately.',
        send_payment_receipt_for: 'Only upload receipts for',
        invalid_order: 'Invalid Order',
        we_couldnt_find_the_transfer_order_you_re_looking_for: 'Hmm… We couldn\'t find the transfer order you\'re looking for.',
        show_my_transfers: 'Show My Transfers',
        monday_is_ok: 'Monday is ok',
        select_payment_method: 'Select Payment Method',
        i_paid_n: 'I PAID {n}',
        pay_n_now: 'Pay {n} Now',
        submit_your_first_order: 'SUBMIT YOUR FIRST ORDER',
        filtered: 'filtered',
        bank_details: 'Bank Details',
        we_need_to_complete_your_verification_before_receiving_orders: 'We need to complete your verification before receiving orders.',
        bypass_transfer_amount_limit: 'Bypass transfer amount limit',
        no_user_found: 'No User Found',
        select_your_recipient: 'Select Your Recipient',
        add_a_new_recipient: 'Add a new Recipient',
        complete_verification: 'Complete verification',
        recipient_s_details : 'Recipient\'s details',
        who_are_you_sending_money_to: 'Who are you sending money to?',
        edit_recipient: 'Edit recipient',
        reason_for_transfer: 'Reason for transfer',
        gift_or_support_family_friends: 'Gift or support family/friends',
        travel_holiday_immigration: 'Travel/Holiday/Immigration',
        real_estate_relocation_rent: 'Real Estate/Relocation/Rent',
        university_tuition_fees: 'University tuition fees',
        pay_salary: 'Pay salary',
        transfer_business_funds: 'Transfer business funds',
        charity: 'Charity',
        other: 'Other',
        type_your_reason_here: 'Type your reason here',
        review_and_confirm: 'Review and confirm',
        example_please_pay_by_sunday: 'Example: Please pay by Sunday.',
        submit_pay_now: 'Submit & Pay Now',
        if_account_owner_name_is_not: 'If the account holder\'s name for the Rial deposit is not {first_name} {last_name}, please enter it here.',
        unavailable_receipt_message: 'If you require a receipt for this transaction we\'ll try our best to extract one for you.',
        total_on_ramp_amounts: 'Total On-ramp amounts',
        total_off_ramp_amounts: 'Total Off-ramp amounts',
        hide_cancelled_orders: 'Hide cancelled orders',
        payment_received_thank_you: 'Payment Received. Thank You!',
        overpayment: 'overpayment',
        select_your_bank_account: 'Select your bank account',
        which_bank_do_you_pay_from: 'Which bank do you pay from?',
        add_a_new_bank_account: 'Add a new bank account'
    }
}
